import { Injectable } from '@angular/core';
import { Howl, Howler } from 'howler';

@Injectable({ providedIn: 'root' })
export class NotificationSoundService {
  private sound: Howl;
  private isAudioAllowed = false; // Flag to track if user has interacted

  constructor() {
    // Initialize on first user interaction (required by browsers)
    window.addEventListener('click', () => this.init(), { once: true });
  }

  private init() {
    this.sound = new Howl({
      src: [
        'assets/sounds/notification.ogg', // Better for Firefox/Linux
        'assets/sounds/notification.mp3'  // Fallback for Safari
      ],
      volume: 0.5,
      html5: true, // Forces HTML5 Audio (better for large files)
      onload: () => {
        this.isAudioAllowed = true;
        console.log('🔊 Sound loaded');
      },
      onloaderror: (_, error) => {
        console.error('❌ Sound load failed:', error);
      },
      onplayerror: () => {
        // Retry once if playback fails
        this.sound.once('unlock', () => this.sound.play());
      }
    });
  }

  play(): void {
    if (!this.isAudioAllowed) {
      console.warn('⚠️ User has not interacted yet. Sound blocked.');
      return;
    }

    // Stop if already playing to avoid overlaps
    if (this.sound.playing()) {
      this.sound.stop();
    }

    this.sound.play();
  }

  // Optional: Change global volume
  setVolume(level: number) {
    Howler.volume(level);
  }
}